import React from 'react';
import { Phone } from 'lucide-react';
export function TrustSection() {
  return <section className="bg-white py-10 lg:py-12 border-b border-gray-100" data-id="element-243">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-244">
        <div className="bg-white rounded-xl p-6 lg:p-10 shadow-sm border border-gray-100 flex flex-col lg:flex-row items-center gap-6 lg:gap-10" data-id="element-245">
          {/* Left: Text content */}
          <div className="flex-1 text-center lg:text-left" data-id="element-246">
            <h2 className="text-xl lg:text-2xl font-bold text-gray-900 mb-2" data-id="element-247">
              Get a FREE NeoLife Membership to Save up to{' '}
              <span className="text-[#9fd23d] text-3xl lg:text-4xl font-extrabold" data-id="element-248">
                25%
              </span>{' '}
              on ALL products
            </h2>
            <p className="text-sm text-gray-500" data-id="element-249">
              Join thousands of satisfied customers who trust NeoLife for their
              daily nutrition.
            </p>
          </div>

          {/* Right: CTA and Phone */}
          <div className="flex flex-col sm:flex-row items-center gap-4 flex-shrink-0" data-id="element-250">
            <a href="http://shopneolife.com/lookfeelbetter/enrollment/enrollmentconfiguration" target="_blank" rel="noopener noreferrer" className="inline-block bg-[#0e7be1] hover:bg-[#0c6bc4] text-white font-semibold text-sm px-6 py-3 rounded-lg transition-colors whitespace-nowrap" data-id="element-251">
              Get 25% Off with Free Membership
            </a>

            <div className="bg-gray-50 py-3 px-5 rounded-lg border border-gray-100" data-id="element-252">
              <p className="text-xs text-gray-500 font-medium mb-0.5 text-center" data-id="element-253">
                Any questions?
              </p>
              <a href="tel:800-260-2808" className="flex items-center justify-center text-lg font-bold text-[#0e7be1] hover:underline" data-id="element-254">
                <Phone className="h-4 w-4 mr-1.5" data-id="element-255" />
                800-260-2808
              </a>
            </div>
          </div>
        </div>

        {/* Distributor link */}
        <p className="text-center mt-4 text-sm text-gray-500" data-id="element-256">
          Interested in earning income or becoming a distributor?{' '}
          <a href="http://shopneolife.com/lookfeelbetter/enrollment/enrollmentconfiguration" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-[#0e7be1] underline" data-id="element-257">
            Learn more →
          </a>
        </p>
      </div>
    </section>;
}